/**
 * If a timestamp has no explicit UTC/offset marker (no trailing Z or ±HH:MM), the JS `Date`
 * constructor treats it as local time instead of UTC. Every timestamp on this API is UTC by
 * convention, so treat an unmarked string as UTC rather than trusting the browser's guess.
 */
function ensureUtcMarker(iso: string): string {
  return /(Z|[+-]\d{2}:?\d{2})$/.test(iso) ? iso : `${iso}Z`;
}

/** Formats an ISO timestamp as a UTC date/time string, with an explicit UTC marker. */
export function formatUtcDateTime(iso: string | null | undefined): string {
  if (!iso) {
    return '—';
  }
  const parsed = new Date(ensureUtcMarker(iso));
  if (Number.isNaN(parsed.getTime())) {
    return '—';
  }
  return new Intl.DateTimeFormat(undefined, {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    timeZone: 'UTC',
    timeZoneName: 'short',
  }).format(parsed);
}
